import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from 'reactstrap';
import SVG from '../svg';
import { PropsTypes } from '../../types/common-elements/CommonElementsTypes';
import H3 from '../headings/H3Element';
import { useTranslation } from 'react-i18next';

interface BreadcrumbLink {
  label: string;
  url?: string;
  active?: boolean;
}

interface NavigationBreadcrumbsProps extends PropsTypes {
  links?: BreadcrumbLink[];
}

const NavigationBreadcrumbs = ({ mainTitle, parent, links = [] }: NavigationBreadcrumbsProps) => {
  const { t } = useTranslation();

  return (
    <Container fluid>
      <div className="page-title">
        <Row>
          <Col sm="6" className="ps-0">
            <H3>{mainTitle}</H3>
          </Col>
          <Col sm="6" className="ps-0">
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                  <SVG iconId="stroke-home" className="stroke-icon" />
                </Link>
              </BreadcrumbItem>
              {parent && (
                <BreadcrumbItem>
                  <Link to={`${process.env.PUBLIC_URL}/masterdata/holidays`}>{t(parent)}</Link>
                </BreadcrumbItem>
              )}
              {links.map((link, index) => (
                <BreadcrumbItem key={index} active={link.active}>
                  {link.url && !link.active ? (
                    <Link to={link.url}>{t(link.label)}</Link>
                  ) : (
                    t(link.label)
                  )}
                </BreadcrumbItem>
              ))}
            </Breadcrumb>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default NavigationBreadcrumbs;